import { useLingui } from '@lingui/react'
import { type FC } from 'react'

import { NOTIFICATION_TYPES } from 'shared/consts'
import { type CartOverdraftsV2 } from 'types/api/cart'
import type { PublicRuntimeConfig } from 'types/shopConfig'
import { NotificationCart } from 'views/components/organisms/Cart/NotificationCart'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import { translateKeys } from './translateKeys'

interface NotificationOverdraftGroupProps {
  overdraft: CartOverdraftsV2
  publicRuntimeConfig: PublicRuntimeConfig
}

const NotificationOverdraftGroup: FC<NotificationOverdraftGroupProps> = ({
  overdraft,
}) => {
  const { i18n } = useLingui()
  return (
    <NotificationCart
      type={NOTIFICATION_TYPES.ATTENTION}
      classNameOverride={'a-full-width'}
    >
      {translateKeys(overdraft, i18n)}
    </NotificationCart>
  )
}

export default withShopAndRuntimeConfig(NotificationOverdraftGroup)
